// import Sample from "components/Sample";
import "assets/css/App.css";
import Header from "Layouts/UI/Header";
import Footer from "Layouts/UI/Footer";
import HeaderBanner from "Layouts/UI/HeaderBanner";
import Aboutus from "Layouts/UI/Aboutus";
import Service from "Layouts/UI/Service";
import Experience from "Layouts/UI/Experience";
import EducationSkills from "Layouts/UI/EducationSkills";
import MyPortfolio from "Layouts/UI/MyPortfolio";
import CustomerReview from "Layouts/UI/CustomerReview";
import RecentArtical from "Layouts/UI/RecentArtical";
import Cursor from "./Cursor";
import ScrollButton from "Layouts/UI/ScrollButton";

const HomePage = () => {
  
  return (
    
      <div className="App">
        <Header />
        <Cursor/>
       <HeaderBanner/>
        
        <main className="">
          <Aboutus />
          {/* <Sample></Sample> */}
         
          <Service/>
          <Experience/>
          <EducationSkills/>
          <MyPortfolio/>
          <CustomerReview/>
          <RecentArtical/>
        </main>
        <Footer></Footer>
        <ScrollButton/>
      </div>
    
  );
};

export default HomePage;
